import { Datum } from '../../';

/**
 * A wrapper for an individual datum (usually part of a time series)
 */
export class IndexDatum extends Datum {
  /**
   * Initialize a Datum pair from an index number and value
   * 
   * @param {Number} index Number describing the index of the measurement
   * @param {Number|Array} value Number (or number array) with measurement(s)
   */
  constructor(index, value) {
    if (!(typeof index === 'number'))
      throw Error('Index is not a valid number');
    if (!(value === null || typeof value === 'number' || Array.isArray(value)))
      throw Error('Value is not a number, null, or Array');

    super(index, value);
  }
}